import { SlideVideo } from '../../../types/interfaces';

import { Media } from './Media';

export class Video extends Media {
  private static readonly transformations =
    'c_scale,dpr_auto,f_auto,q_auto,t_productPageHeroGalleryTransformation_v2,w_auto,e_volume:mute';

  private constructor(
    private readonly _id: string,
    private readonly _deliveryUrl: string,
    private readonly _autoplay?: boolean,
    private readonly _loop?: boolean,
    private readonly _altText?: string,
    private readonly _posterImage?: string,
    private readonly _smallPosterImage?: string,
    private readonly _name?: string,
    private readonly _description?: string
  ) {
    super();
  }

  get id(): string {
    return this._id;
  }

  get thumbnail(): string {
    return (
      this._smallPosterImage ??
      `${this._deliveryUrl}/video/upload/${Video.transformations}/${this._id}.jpg`
    );
  }

  get videoUrl(): string {
    return `${this._deliveryUrl}/video/upload/${Video.transformations}/${this._id}`;
  }

  get autoplay(): boolean {
    return this._autoplay ?? false;
  }

  get loop(): boolean {
    return this._loop ?? false;
  }

  get videoAlt(): string | undefined {
    return this._altText;
  }

  get posterImage(): string | undefined {
    return this._posterImage;
  }

  get name(): string | undefined {
    return this._name;
  }

  get description(): string | undefined {
    return this._description;
  }

  equals(media: Media): boolean {
    if (!(media instanceof Video)) {
      return false;
    }
    return (
      this._id === media._id &&
      this._deliveryUrl === media._deliveryUrl &&
      this._autoplay === media._autoplay &&
      this._loop === media._loop &&
      this._altText === media._altText &&
      this._posterImage === media._posterImage &&
      this._smallPosterImage === media._smallPosterImage &&
      this._name === media._name &&
      this._description === media._description
    );
  }

  copy(): Video {
    return new Video(
      this._id,
      this._deliveryUrl,
      this._autoplay,
      this._loop,
      this._altText,
      this._posterImage,
      this._smallPosterImage,
      this._name,
      this._description
    );
  }

  static from(video: SlideVideo): Video {
    return new Video(
      video.id,
      video.deliveryUrl,
      video.autoplay,
      video.loop,
      video.altText,
      video.posterImage,
      video.smallPosterImage,
      video.name,
      video.description
    );
  }
}
